import { useTranslation } from 'react-i18next';

import { Container } from '../components/MenuBar';
import NavGroup from '../components/MenuBar/NavGroup';
import { useAccountId } from '../auth/useAccountId';
import { AllowDinteroRoot } from '../auth/accessToken/Allow';

const Menu = () => {
    const { t } = useTranslation();
    const accountId = useAccountId();

    return (
        <Container>
            <NavGroup
                mainLink={{
                    path: `/${accountId}/settings/account`,
                    label: t('settings.menu.account'),
                }}
                subLinks={[
                    {
                        path: `/${accountId}/settings/account`,
                        label: t('settings.menu.account_info'),
                    },
                    {
                        path: `/${accountId}/settings/users`,
                        label: t('settings.menu.users'),
                    },
                    {
                        path: `/${accountId}/settings/locations`,
                        label: t('settings.menu.locations'),
                    },
                ]}
            />
            <AllowDinteroRoot fallback={
                <NavGroup
                    mainLink={{
                        path: `/${accountId}/settings/payment-connections`,
                        label: t('settings.menu.payments_and_payouts'),
                    }}
                    subLinks={[
                        {
                            path: `/${accountId}/settings/payment-connections`,
                            label: t('settings.menu.payment_connections'),
                        },
                        {
                            path: `/${accountId}/settings/payment-profiles`,
                            label: t('settings.menu.payment_profiles'),
                        },
                    ]}
                />
            }>
                <NavGroup
                    mainLink={{
                        path: `/${accountId}/settings/payment-connections`,
                        label: t('settings.menu.payments_and_payouts'),
                    }}
                    subLinks={[
                        {
                            path: `/${accountId}/settings/payment-connections`,
                            label: t('settings.menu.payment_connections'),
                        },
                        {
                            path: `/${accountId}/settings/payment-connections/gateways`,
                            label: t('settings.menu.gateway_settings'),
                        },
                        {
                            path: `/${accountId}/settings/payment-profiles`,
                            label: t('settings.menu.payment_profiles'),
                        },
                    ]}
                />
            </AllowDinteroRoot>
            <NavGroup
                mainLink={{
                    path: `/${accountId}/settings/sellers`,
                    label: t('settings.menu.split_payment'),
                }}
                subLinks={[
                    {
                        path: `/${accountId}/settings/sellers`,
                        label: t('settings.menu.payout_destinations'),
                    },
                    {
                        path: `/${accountId}/settings/payout-rules`,
                        label: t('settings.menu.payout_rules'),
                    },
                ]}
            />
            <NavGroup
                mainLink={{
                    path: `/${accountId}/settings/reports`,
                    label: t('settings.menu.reports'),
                }}
                subLinks={[
                    {
                        path: `/${accountId}/settings/reports`,
                        label: t('settings.menu.insight_reports'),
                    },
                    {
                        path: `/${accountId}/settings/payout-report-configs`,
                        label: t('settings.menu.payout_reports'),
                    },
                ]}
            />
            <NavGroup
                mainLink={{
                    path: `/${accountId}/settings/clients`,
                    label: t('settings.menu.integrations'),
                }}
                subLinks={[
                    {
                        path: `/${accountId}/settings/third-party`,
                        label: t('settings.menu.third_party'),
                    },
                    {
                        path: `/${accountId}/settings/clients`,
                        label: t('settings.menu.api_clients'),
                    },
                    {
                        path: `/${accountId}/settings/hooks`,
                        label: t('settings.menu.hooks'),
                    },
                ]}
            />
        </Container>
    );
};

export default Menu;
